var _metadata, _sodipodiNamedview, _defs, _tspan, _tspan2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg16(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    id: "svg2",
    inkscapeVersion: "0.47 r22583",
    sodipodiDocname: "ADR 1.6.svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", {
    id: "metadata24"
  }, /*#__PURE__*/React.createElement("rdfRDF", null, /*#__PURE__*/React.createElement("ccWork", {
    rdfAbout: ""
  }, /*#__PURE__*/React.createElement("dcFormat", null, "image/svg+xml"), /*#__PURE__*/React.createElement("dcType", {
    rdfResource: "http://purl.org/dc/dcmitype/StillImage"
  }))))), _sodipodiNamedview || (_sodipodiNamedview = /*#__PURE__*/React.createElement("sodipodiNamedview", {
    pagecolor: "#ffffff",
    bordercolor: "#666666",
    borderopacity: 1,
    objecttolerance: 10,
    gridtolerance: 10,
    guidetolerance: 10,
    inkscapePageopacity: 0,
    inkscapePageshadow: 2,
    "inkscapeWindow-width": 1280,
    "inkscapeWindow-height": 976,
    id: "namedview22",
    showgrid: "false",
    inkscapeZoom: 1.888,
    inkscapeCx: 97.79682,
    inkscapeCy: 126.75667,
    "inkscapeWindow-x": 0,
    "inkscapeWindow-y": 24,
    "inkscapeWindow-maximized": 1,
    "inkscapeCurrent-layer": "svg2"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs6"
  }, /*#__PURE__*/React.createElement("inkscapePerspective", {
    sodipodiType: "inkscape:persp3d",
    inkscapeVp_x: "0 : 500 : 1",
    inkscapeVp_y: "0 : 1000 : 0",
    inkscapeVp_z: "1000 : 500 : 1",
    "inkscapePersp3d-origin": "500 : 333.33333 : 1",
    id: "perspective26"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 5950,0 0,7197.12 -5950,0 L 0,0 z",
    id: "path22"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g3353",
    transform: "scale(0.1,0.1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2818"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fc7e0c"
    },
    id: "path2826",
    d: "M 0,500 500,0 1000,500 c 0,0 -500,500 -500,500 L 0,500 z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#000000"
    },
    id: "g3779",
    transform: "matrix(0.13736741,0,0,-0.13736741,4.7212755,992.23093)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path64",
    d: "m 3798.75,4452.35 2.71,0.75 -2.94,0.14 0.23,-0.89"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g3039",
    transform: "translate(75.113702,-23.920505)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path124",
    d: "m 3484.04,1533.44 c -5.43,-18.42 -13.45,-33.15 -24.04,-44.18 -15.46,-16.15 -35.49,-26.92 -60.1,-32.29 -15.47,-3.39 -42.5,-5.95 -81.13,-7.65 l 0,-83.75 146.25,0 0,-430 124.98,0 0,622.5 -101.23,0 c 0,-5.39 -1.58,-13.6 -4.73,-24.63"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path132",
    d: "m 3652.84,2039.32 -101.09,-32.76 0,117.68 -83.75,0 0,-117.4 -101.13,32.73 -22.62,-72.09 102.96,-31.99 -67.67,-96.25 63.13,-44.63 67.95,90.12 65.96,-90.14 63.05,44.65 -67.11,96.25 102.82,31.99 -22.5,71.84"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#080400"
    },
    id: "path2820",
    d: "m 55,500 c 0,0 443.3666,-445 445,-445 1.3076,0 445,443.69239 445,445 0,1.63343 -445,445 -445,445 C 500,945 55,500 55,500 z M 925,500 500,75 c 0,0 -425,425 -425,425 0,0 425,425 425,425 L 925,500 z"
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fontSize: 20,
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "bold",
      fontStretch: "normal",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      fontFamily: "FreeSans",
      InkscapeFontSpecification: "FreeSans Bold"
    },
    xmlSpace: "preserve",
    id: "text2819",
    y: 796.34534,
    x: 415.26654
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan2821",
    y: 796.34534,
    x: 415.26654
  }))), /*#__PURE__*/React.createElement("text", {
    style: {
      fontSize: 20,
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "bold",
      fontStretch: "normal",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      fontFamily: "Verdana",
      InkscapeFontSpecification: "Verdana Bold"
    },
    xmlSpace: "preserve",
    id: "text2853",
    y: 773.9657,
    x: 424.46704
  }, _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan2855",
    y: 773.9657,
    x: 424.46704
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#000000"
    },
    id: "g2846",
    transform: "matrix(0.13504738,0,0,-0.13504738,10.742592,963.92777)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path34",
    d: "m 3236.62,3531.68 312.5,0 0,312.5 -312.5,0 0,-312.5 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path36",
    d: "m 2750.49,4931.41 c -12.74,-43.17 -31.45,-77.7 -56.21,-103.6 -36.13,-37.85 -82.97,-63.08 -140.51,-75.7 -36.17,-7.97 -99.41,-13.94 -189.73,-17.93 l 0,-195 342.5,0 0,-1007.5 295,0 0,1457.5 -240,0 c 0,-12.62 -3.71,-31.87 -11.05,-57.77"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path38",
    d: "m 4134.34,4196.72 c 39.12,29.4 84.2,44.1 135.21,44.1 62.83,0 115.96,-22.6 159.28,-67.69 43.32,-45.11 64.98,-110.12 64.98,-195.04 0,-76.19 -19.1,-138.2 -57.21,-185.98 -38.16,-47.84 -90.47,-71.7 -156.91,-71.7 -67.89,0 -123.89,24.7 -167.97,74.18 -44.08,49.47 -66.13,113.32 -66.13,191.55 0,96.94 29.59,167.12 88.75,210.58 z m 142.03,-709.59 c 179.1,0 311.13,51.77 396.11,155.45 84.96,103.63 127.48,223.31 127.48,359.03 0,136.38 -43.4,248.37 -130.12,335.98 -86.75,87.57 -197.89,131.39 -333.43,131.39 -63.23,0 -119.44,-9.7 -168.58,-29.04 -49.18,-19.35 -92.38,-50.03 -129.59,-92.05 8.42,112.19 23.93,197.04 46.51,254.48 41.56,104.18 111.29,156.29 209.18,156.29 65.5,0 114.45,-22.88 146.87,-68.54 18.99,-28.19 28.52,-54.07 28.52,-77.58 l 298.81,0 c -10.57,114.8 -57.99,206.72 -142.33,275.78 -84.35,69.07 -197.56,103.63 -339.53,103.63 -98.44,0 -182.93,-21.27 -253.57,-63.81 -70.65,-42.54 -127.8,-98.9 -171.33,-169 -50.65,-82.15 -84.75,-184.98 -102.27,-308.51 -9.86,-69.45 -14.76,-159.63 -14.76,-270.46 0,-188.98 35.43,-343.23 106.38,-462.77 91.31,-153.54 233.19,-230.27 425.65,-230.27"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg16);
export default __webpack_public_path__ + "static/media/1.6.4dea7372f6791072f87992ab5269639f.svg";
export { ForwardRef as ReactComponent };